<template>
    <div class="role-message-wrapper">
        {{ title }}
    </div>
</template>

<script>
export default {
    name: "RoleMessage",
    computed: {
        title() {
            return this.$t("zhiji.form.roleMessage.title");
        }
    }
};
</script>

<style lang="scss" scoped>
.role-message-wrapper {
    font-size: 12px;
    padding: 8px 0 8px 8px;
    width: 594px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
